import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IAssemblyAppStyles } from "./AssemblyApp.types"

export const AssemblyAppStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IAssemblyAppStyles>
> = (theme: IPartialTheme) => ({
    loadingRoot: {
        background: theme.semanticColors?.bodyBackground
    }
})
